<template>
    <b-modal
        :id="id"
        v-model="isModalOpen"
        :title="title"
        :ok-only="okOnly"
        :ok-title="okTitle"
        :ok-variant="okVariant"
        :hide-footer="hideFooter"
        :ok-disabled="okDisabled"
        :cancel-title="cancelTitle"
        :cancel-variant="cancelVariant"
        :cancel-disabled="cancelDisabled"
        :no-close-on-esc="noCloseOnEsc"
        :no-close-on-backdrop="noCloseOnBackdrop"
        :hide-header-close="hideHeaderClose"
        :size="size"
        :button-size="buttonSize"
        :scrollable="scrollable"
        :centered="centered"
        @hidden="closeModal()"
        @ok="$emit('okHandler', $event, closeModal)"
        @hide="$emit('hideHandler', $event, closeModal)"
        @cancel="$emit('cancelHandler', $event, closeModal)"
    >
        <slot></slot>
        <template slot="modal-ok">
            <slot name="okButton"></slot>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: 'Modal',
    props: {
        id: {
            type: String,
            default: '',
            required: false,
        },
        title: {
            type: String,
            default: '',
            required: true,
        },
        isModalRoute: {
            type: Boolean,
            default: false,
            required: true,
        },
        isOpen: {
            default: true,
            type: Boolean,
        },
        okOnly: {
            default: false,
            type: Boolean,
        },
        okTitle: {
            default: 'Ok',
            type: String,
        },
        okVariant: {
            default: 'primary',
            type: String,
        },
        okDisabled: {
            default: false,
            type: Boolean,
        },
        cancelTitle: {
            default: 'Cancel',
            type: String,
        },
        cancelVariant: {
            default: 'secondary',
            type: String,
        },
        cancelDisabled: {
            default: false,
            type: Boolean,
        },
        buttonSize: {
            default: 'sm',
            type: String,
        },
        size: {
            default: 'md',
            type: String,
        },
        noCloseOnEsc: {
            default: false,
            type: Boolean,
        },
        noCloseOnBackdrop: {
            default: false,
            type: Boolean,
        },
        hideHeaderClose: {
            default: false,
            type: Boolean,
        },
        hideFooter: {
            default: false,
            type: Boolean,
        },
        scrollable: {
            default: false,
            type: Boolean,
        },
        centered: {
            default: false,
            type: Boolean,
        },
    },
    computed: {
        isModalOpen: {
            set(value) {
                this.$emit('update:isOpen', value)
            },
            get() {
                return this.$props.isOpen
            },
        },
    },
    methods: {
        closeModal() {
            this.isModalOpen = false
            if (this.isModalRoute) this.$router.go(-1)
        },
    },
}
</script>

<style>
@media (max-width: 576px) {
    .modal-footer {
        display: block;
    }
    .modal-footer button {
        display: block;
        width: 100%;
        margin: 0 !important;
    }
    .modal-footer button:nth-child(2) {
        margin-top: 8px !important;
    }
}
</style>
